// Curated starter templates for devotional types. Each template is a complete
// list of field definitions admins can apply in one click. They can still edit,
// reorder, or delete fields afterwards via the FieldsManager.

export const FIELD_TEMPLATES = [
  {
    id: "daily_devotional",
    label: "Daily Devotional",
    description: "Classic 5-section daily reading: Topic, Scripture, Message, Prayer, Confession.",
    fields: [
      { field_name: "Topic",        field_key: "topic",        field_type: "text",                 required: true,  allow_audio: true },
      { field_name: "Scripture",    field_key: "scripture",    field_type: "scripture_reference",  required: true,  allow_audio: true },
      { field_name: "Introduction", field_key: "introduction", field_type: "textarea",             required: false, allow_audio: true },
      { field_name: "Message",      field_key: "message",      field_type: "rich_text",            required: true,  allow_audio: true },
      { field_name: "Prayer",       field_key: "prayer",       field_type: "textarea",             required: true,  allow_audio: true },
      { field_name: "Confession",   field_key: "confession",   field_type: "textarea",             required: false, allow_audio: true },
    ],
  },
  {
    id: "bible_study",
    label: "Bible Study",
    description: "In-depth study layout: Topic, Introduction, Scripture, Study Notes, Questions, Reflection, Action Points.",
    fields: [
      { field_name: "Topic",          field_key: "topic",          field_type: "text",                 required: true,  allow_audio: true },
      { field_name: "Introduction",   field_key: "introduction",   field_type: "textarea",             required: true,  allow_audio: true },
      { field_name: "Scripture",      field_key: "scripture",      field_type: "scripture_reference",  required: true,  allow_audio: true },
      { field_name: "Study Notes",    field_key: "study_notes",    field_type: "rich_text",            required: true,  allow_audio: true },
      { field_name: "Questions",      field_key: "questions",      field_type: "numbered_list",        required: true,  allow_audio: true },
      { field_name: "Reflection",     field_key: "reflection",     field_type: "textarea",             required: true,  allow_audio: true },
      { field_name: "Action Points",  field_key: "action_points",  field_type: "numbered_list",        required: false, allow_audio: true },
    ],
  },
  {
    id: "sermon_notes",
    label: "Sermon Notes",
    description: "Speaker-led format: Title, Speaker, Scripture, Main Points, Key Quotes, Application.",
    fields: [
      { field_name: "Title",         field_key: "title_field",  field_type: "text",                 required: true,  allow_audio: false },
      { field_name: "Speaker",       field_key: "speaker",      field_type: "text",                 required: false, allow_audio: false },
      { field_name: "Scripture",     field_key: "scripture",    field_type: "scripture_reference",  required: true,  allow_audio: true  },
      { field_name: "Main Points",   field_key: "main_points",  field_type: "numbered_list",        required: true,  allow_audio: true  },
      { field_name: "Key Quotes",    field_key: "key_quotes",   field_type: "textarea",             required: false, allow_audio: true  },
      { field_name: "Application",   field_key: "application",  field_type: "rich_text",            required: true,  allow_audio: true  },
    ],
  },
  {
    id: "topical_study",
    label: "Topical Study",
    description: "Theme-driven layout: Theme, Key Verses, Cross References, Insights, Personal Application.",
    fields: [
      { field_name: "Theme",                field_key: "theme",                field_type: "text",                 required: true, allow_audio: false },
      { field_name: "Key Verses",           field_key: "key_verses",           field_type: "list",                 required: true, allow_audio: true  },
      { field_name: "Cross References",     field_key: "cross_references",     field_type: "list",                 required: false, allow_audio: true },
      { field_name: "Insights",             field_key: "insights",             field_type: "rich_text",            required: true, allow_audio: true  },
      { field_name: "Personal Application", field_key: "personal_application", field_type: "textarea",             required: true, allow_audio: true  },
    ],
  },
];
